module.exports = __webpack_public_path__ + "static/media/BannerDMS.9c16fe61.jpeg";